import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { CampaignsService } from 'src/app/services/api/campaigns.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-campaign-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './campaigns-detail-page.component.html',
  styleUrl: './campaigns-detail-page.component.scss'
})
export class CampaignDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean

  campaign?: any;

  constructor(
    private campaignsService: CampaignsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Campaigns',
      cardTitle: 'Campaign Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Campaign',
        onClick: () => {
          this.routeService.campaignUpdate(this.campaign.campaignId)
        }
      },
      dataList: {
        data: null,
        rows: [          
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
          {
            attribute: 'validFrom',
            label: 'Valid From',
            value: (item: any) => {
              return item.startTime;
            }
          },
          {
            attribute: 'validTo',
            label: 'Valid To',
            value: (item: any) => {
              return item.endTime;
            }
          },
          {
            attribute: 'discount',
            label: 'Discount %',
            value: (item: any) => {
              return item.discountPercent;
            }
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return item.createTime;
            }
          },
        ]
      },
      apiDetailService: (campaignId: number) => this.campaignsService.detail(campaignId),
      routeParamName: 'campaignId',
      responseModelName: 'campaign'
    };

  }

  onLoadedDetail(data: any) {
    this.campaign = data;
  }
}
